// @flow
import Series from '../Series';
/**
 * @property {string} PatientID
 * @property {string} PatientName
 * @property {string} PatientBirthDate
 * @property {Object[]} study
 */
export default class Patient {
  PatientID: string;

  PatientName: string;

  PatientAge: string;

  PatientWeight: String;

  PatientBirthDate: string;

  PatientSex: string;

  ReferringPhysicianName: string;

  mainStudyId: string;

  studies: Array<Object> = [];

  patientHistory: Array<Object> = [];
}
